import { ReactElement, useMemo } from 'react'
import { SimpleTreeView, TreeItem } from '@mui/x-tree-view-pro'
import { useSnackbar } from '@ui/snackbar'
import { DraggablePopup } from '@ui/structure'
import { useControlStore } from '@editorStores'
import { useElementPropertiesTreeInformation } from '@editorHooks'

const PropertiesPopup = () => {
  const propertiesPopupSelectedElement = useControlStore(
    state => state.propertiesPopupSelectedElement,
  )
  const setPropertiesPopupSelectedElement = useControlStore(
    state => state.setPropertiesPopupSelectedElement,
  )
  const { enqueueSnackbar } = useSnackbar()

  const information = useElementPropertiesTreeInformation(propertiesPopupSelectedElement)

  // TREE VIEW SELECTION

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const toTree = (data: any, depth: string): ReactElement[] => {
    if (!data) return []

    return Object.entries(data).map(([key, val], index) => {
      const nodeId = `${depth}-${index}`

      if (typeof val === 'object') {
        return (
          <TreeItem key={nodeId} itemId={nodeId} label={key}>
            {toTree(val, nodeId)}
          </TreeItem>
        )
      }

      return (
        <TreeItem
          key={nodeId}
          itemId={nodeId}
          label={`${key}: ${val}`}
          onClick={() => {
            const content = val?.toString() || ''
            navigator.clipboard.writeText(content.replace('.', ','))
            enqueueSnackbar('Wert wurde in die Zwischenablage kopiert', { variant: 'info' })
          }}
        />
      )
    })
  }

  const anchorEl = useMemo(() => {
    if (propertiesPopupSelectedElement) {
      return document.getElementById('popup-anchor') || undefined
    }
    return undefined
  }, [propertiesPopupSelectedElement])

  return (
    <DraggablePopup
      title="Eigenschaften"
      closePopover={() => setPropertiesPopupSelectedElement(null)}
      anchorEl={anchorEl}
    >
      {information && (
        <SimpleTreeView sx={{ height: 240, flexGrow: 1, width: 400, overflowY: 'auto' }}>
          {toTree(information, 'root')}
        </SimpleTreeView>
      )}
    </DraggablePopup>
  )
}

export default PropertiesPopup
